export default {
  '--primary': '#8c2fdf',
  '--secondary': '#fbbf24',
  '--background': '#ffffff',
  '--text': '#111827',
  '--brand-green': '#2A805A',
  '--brand-green-dark': '#1A9496',
  '--brand-green-light': '#CBF0E0',
  '--brand-green-light-dark': '#1A9496',
  '--cream': '#FFFCF5',
  '--yellow-dark': '#A17805',
  'primary-text': '#101828',
}
